import React from "react";
import { Helmet } from "react-helmet";
import "../styles/Qanunvericilik.css";

const SaytdanIstifadeSertleri = () => {
  return (
    <div className="qanunvericilik-page">
      <Helmet>
        <title>Saytdan istifadə şərtləri | DostTech</title>
        <meta
          name="description"
          content="DostTech.az saytdan istifadə şərtləri və qaydaları."
        />
      </Helmet>
      <div className="container qanunvericilik-inner">
        <h1 className="qanunvericilik-title">Saytdan istifadə şərtləri</h1>
        <p className="qanunvericilik-intro">
          Bu səhifədə veb saytımızdan istifadə qaydaları, istifadəçi öhdəlikləri,
          məsuliyyətin hədləri və mübahisələrin həlli ilə bağlı şərtlər
          yerləşdiriləcəkdir. Mətn hazır olduqda burada tam məzmun təqdim olunacaqdır.
        </p>
        <section className="qanunvericilik-section" aria-labelledby="sec-terms-body">
          <h2 id="sec-terms-body">Məzmun</h2>
          <p className="qanunvericilik-placeholder">[Məlumat təqdim olunacaq]</p>
        </section>
      </div>
    </div>
  );
};

export default SaytdanIstifadeSertleri;
